/**
 * Cloudflare Image Resizing helper for Auxo Asset CDN
 * Transforms original asset URLs to optimized WebP/AVIF versions
 */
export function getOptimizedImageUrl(url, { width = 800, quality = 85, height = null, fit = 'cover' } = {}) {
  if (!url || typeof url !== 'string') return '';
  
  // If not on assets.auxodev.dk or already transformed, return as is
  if (!url.includes('assets.auxodev.dk') || url.includes('/cdn-cgi/image/')) {
    return url;
  }

  const parts = url.split('assets.auxodev.dk/');
  if (parts.length < 2) return url;

  let options = `format=auto,quality=${quality},width=${width}`;
  if (height) {
    options += `,height=${height},fit=${fit}`;
  }

  return `https://assets.auxodev.dk/cdn-cgi/image/${options}/${parts[1]}`;
}
